import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

export const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const location = useLocation();
  const { isAuthenticated, user } = useSelector((state) => state.auth);

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  // If authenticated but role not allowed, redirect to appropriate dashboard
  if (allowedRoles.length > 0 && user && !allowedRoles.includes(user.role)) {
    // Redirect to user's own dashboard based on their role
    if (user.role === 'player') {
      return <Navigate to="/player/dashboard" replace />;
    } else if (user.role === 'coach') {
      return <Navigate to="/coach/dashboard" replace />;
    } else if (user.role === 'scout') {
      return <Navigate to="/scout/dashboard" replace />;
    } else if (user.role === 'admin' || user.role === 'superAdmin') {
      return <Navigate to="/admin/dashboard" replace />;
    }
    return <Navigate to="/" replace />;
  }

  // User is authenticated and has correct role
  return children;
};

export default ProtectedRoute;
